module.exports = __webpack_public_path__ + "media/auth/login-background-3-2010f6f7.jpg";